import axios from 'axios';
import {CONFIG, URLS, getAccessToken} from '../helpers/Common';


export const QUESTION = {
    getChiefComplainTypes,
    getQuestionsByComplainType,
    savePatientNarratives,
    savePatientNarrativesById
    // pendingPatientNarratives,
    // patientNarrativesDetails,
    // acceptNarrative,
    // exportNarrative,
    // searchQuestion,
    // getPatientNarrativeDetails,
    // updatepatientNarratives,
    // addQuestionBySurgeon
};

function getQuestionsByComplainType(complain_type_id)
{   
    let data = new FormData();
   // data.append('token',getAccessToken());
   // data.append('complain_type_id',complain_type_id);
    let requestOptions = {
        method:'GET',
        headers:{
            'X-Auth-Token': getAccessToken(),
        },
     //   data,
        url:`${CONFIG.API_URL+URLS.getQuestionsByComplainType}/${complain_type_id}`

    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

function getChiefComplainTypes()
{   
    // let data = new FormData();
    // data.append('token',getAccessToken());
    let requestOptions = {
        method:'GET',
        headers:{
            'X-Auth-Token': getAccessToken(),
        },
       // data,
        url:`${CONFIG.API_URL+URLS.getChiefComplainTypes}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

function savePatientNarratives(formData)
{   
    
    let data = new FormData();
    //data.append('token',getAccessToken());
    data.append('data',JSON.stringify(formData));
    //console.log(data)
    let requestOptions = {
        method:'POST',
        headers:{
            'X-Auth-Token': getAccessToken(),
        },
        data,
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        url:`${CONFIG.API_URL+URLS.savePatientNarratives}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

function savePatientNarrativesById(formData)
{   
    
    let data = new FormData();
    //data.append('token',getAccessToken());
    data.append('data',JSON.stringify(formData));
    //console.log(data)
    let requestOptions = {
        method:'POST',
        headers:{
            'X-Auth-Token': getAccessToken(),
        },
        data,
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        url:`${CONFIG.API_URL+URLS.savePatientNarrativesById}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

